var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6251 6.73418C17.4701 5.60763 16.6662 4 15.2581 4L4.0935 4C2.68532 4 1.88151 5.60763 2.72641 6.73418V6.73418C3.34266 7.55584 3.67578 8.5552 3.67578 9.58228V16C3.67578 18.2091 5.46664 20 7.67578 20L11.6758 20C13.8849 20 15.6758 18.2091 15.6758 16L15.6758 9.58228C15.6758 8.5552 16.0089 7.55584 16.6251 6.73418V6.73418Z",
    stroke: "#0D4740",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.67578 15L7.67578 9",
    stroke: "#0D4740",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.6758 15L11.6758 9",
    stroke: "#0D4740",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M5.67578 4L6.21993 2.36754C6.49216 1.55086 7.25644 1 8.1173 1L11.2343 1C12.0951 1 12.8594 1.55086 13.1316 2.36754L13.6758 4",
    stroke: "#0D4740",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete2);
export default __webpack_public_path__ + "static/media/delete-2.17070fd14ed0f323b663b73e193e1d5a.svg";
export { ForwardRef as ReactComponent };